var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"5","cy":"12","r":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"2"}}),_c('circle',{attrs:{"cx":"19","cy":"12","r":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }